/**
 * @returns {Object} Mileage entry methods (bound to `this` of the composed apiService)
 */
export function createMileageMethods() {
  return {
    /**
     * Create a mileage entry for an encounter
     * Xano: POST /mileage-entry
     * @param {Object} data
     * @returns {Promise<import('@prism-ehr/shared').MileageEntry>}
     */
    createMileageEntry(data) {
      return this.request('/mileage-entry', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    /**
     * Get mileage entries with optional filters
     * Xano: GET /mileage-entry
     * @param {Object} [filters={}]
     * @param {string} [filters.encounter_id]
     * @param {string} [filters.provider_id]
     * @param {string} [filters.patient_id]
     * @param {string} [filters.organization_id]
     * @returns {Promise<import('@prism-ehr/shared').MileageEntry[]>}
     */
    getMileageEntries(filters = {}) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => {
        if (v != null && v !== '') params.set(k, String(v));
      });
      const qs = params.toString();
      return this.request(`/mileage-entry${qs ? `?${qs}` : ''}`, { method: 'GET' });
    },

    /**
     * Get a single mileage entry
     * Xano: GET /mileage-entry/{mileage_entry_id}
     * @param {string} id
     * @returns {Promise<import('@prism-ehr/shared').MileageEntry>}
     */
    getMileageEntry(id) {
      return this.request(`/mileage-entry/${id}`, { method: 'GET' });
    },

    /**
     * Update a mileage entry
     * Xano: PATCH /mileage-entry/{mileage_entry_id}
     * @param {string} id
     * @param {Object} data
     * @returns {Promise<import('@prism-ehr/shared').MileageEntry>}
     */
    updateMileageEntry(id, data) {
      return this.request(`/mileage-entry/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },

    /**
     * Delete a mileage entry
     * Xano: DELETE /mileage-entry/{mileage_entry_id}
     * @param {string} id
     * @returns {Promise<void>}
     */
    deleteMileageEntry(id) {
      return this.request(`/mileage-entry/${id}`, { method: 'DELETE' });
    },
  };
}
